import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const activateContract = (id,items,amort)=> {
	return axios.post(API + "contracts/contractloan-activate/"+id+"/" ,{items,amort},{ headers: authHeader() })}

const ActivateContractLoanService = {
    activateContract,
  };
  export default ActivateContractLoanService;